module.exports = __webpack_public_path__ + "static/leader1-ef073ca5e24aec4f486d19c1478b731e.png";